import { useState } from "react";
import { PlayCircle, Film } from "lucide-react";
import { parseVideo } from "@/components/VideoManager";

function VideoCard({ url, index }) {
  const v = parseVideo(url);
  const [playing, setPlaying] = useState(false);

  if (v.kind === "video") {
    return (
      <div className="relative aspect-video rounded-2xl overflow-hidden border border-slate-200 bg-black shadow-sm" data-testid={`biz-video-${index}`}>
        <video src={v.src} controls className="w-full h-full object-cover" preload="metadata" />
      </div>
    );
  }
  return (
    <div className="relative aspect-video rounded-2xl overflow-hidden border border-slate-200 bg-slate-900 shadow-sm group" data-testid={`biz-video-${index}`}>
      {playing ? (
        <iframe src={`${v.src}?autoplay=1`} title={`Vidéo ${index + 1}`} className="w-full h-full"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen />
      ) : (
        <button onClick={() => setPlaying(true)} className="absolute inset-0 w-full h-full" data-testid={`biz-video-play-${index}`}>
          {v.poster
            ? <img src={v.poster} alt="" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            : <div className="w-full h-full grid place-items-center text-white/70"><Film size={36} /></div>}
          <span className="absolute inset-0 grid place-items-center">
            <PlayCircle size={60} className="text-white drop-shadow-lg group-hover:scale-110 transition-transform" />
          </span>
        </button>
      )}
    </div>
  );
}

export default function BusinessVideos({ videos = [] }) {
  if (!videos.length) return null;
  return (
    <section data-testid="biz-videos">
      <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight text-slate-900 flex items-center gap-2">
        <Film size={22} className="text-[#E05638]" /> Vidéos &amp; présentation
      </h2>
      <div className="mt-4 grid grid-cols-1 sm:grid-cols-2 gap-5">
        {videos.map((url, i) => <VideoCard key={`${i}-${url}`} url={url} index={i} />)}
      </div>
    </section>
  );
}
